import React, { useState, useRef, useEffect } from 'react';
import { Container, Button, Row, Col ,Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';
import './_home-banner.scss';
import { Autoplay, FreeMode, Navigation, Thumbs, EffectFade } from 'swiper/modules';
import {BtnArrow} from '../../../../resources/js/components/svgIcon';
import AOS from 'aos';

function Banner({ BannerArr }) {
    const cdn_path = window.cdn_path;
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [isMuted, setIsMuted] = useState(true);
    const mainSwiperRef = useRef(null);
    const [swiperKey, setSwiperKey] = useState(0);
    const activeVideoRef = useRef(null);

    useEffect(() => {
        AOS.refresh();
    }, []);

    useEffect(() => {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);

        const onYouTubeAPIReady = () => {
            if (window.YT && window.YT.Player) {
                document.querySelectorAll('iframe[src*="youtube.com"]').forEach(iframe => {
                    new window.YT.Player(iframe, {
                        events: {
                            'onStateChange': (event) => {
                                setTimeout(() => {
                                    if (sliderRef.current) {
                                      sliderRef.current.slideNext();
                                    }
                                  }, 100);
                            }
                        }
                    });
                });
            }
        };

        window.onYouTubeIframeAPIReady = onYouTubeAPIReady;

        return () => {
            delete window.onYouTubeIframeAPIReady; // Clean up function
        };
    }, []);

    const handleVideoPlay = (video, index) => {
        if (mainSwiperRef.current) {
            mainSwiperRef.current.swiper.autoplay.stop();
        }

        video.onended = () => {
            // console.log("Video ended.");
            // Check if it's the last slide
            if (index === BannerArr.length - 1) {
                // console.log("Last slide video ended. Refreshing slider...");
                setTimeout(() => {
                    setSwiperKey(prevKey => prevKey + 1); // Force Swiper refresh
                }, 1000); // Short delay before restarting
            } else {
                mainSwiperRef.current.swiper.slideNext();
            }
        };
    };

    return (
        <section className='home-banner homebanner position-relative'>
            <div className='hb-img'>
                <Swiper
                    ref={mainSwiperRef}
                    loop={true}
                    spaceBetween={0}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    navigation={{
                        nextEl: '.custom-swiper-button-next',
                        prevEl: '.custom-swiper-button-prev',
                    }}
                    thumbs={{ swiper: thumbsSwiper }}
                    effect="fade"
                    fadeEffect={{ crossFade: true }}
                    modules={[Autoplay, FreeMode, Navigation, Thumbs, EffectFade]}
                    className="mySwiper2"
                     onReachEnd={() => {
                        console.log("End of loop reached, restarting slider...");
                        setTimeout(() => {
                            if (mainSwiperRef.current) {
                                mainSwiperRef.current.swiper.slideTo(0, 0); // Jump back to the first slide instantly
                            }
                        }, 2000); // Small delay to prevent flickering
                    }}
                                    onSlideChange={(swiper) => {
                        const previousSlide = swiper.slides[swiper.previousIndex];
                        const activeSlide = swiper.slides[swiper.activeIndex];

                        // **Pause and reset all regular videos**
                        document.querySelectorAll('.thumbnail video').forEach((video) => {
                            video.pause();
                            // video.currentTime = 0;
                        });

                        // **Stop autoplay for previous YouTube iframe**
                        const prevIframe = previousSlide.querySelector('iframe');
                        if (prevIframe) {
                            let prevSrc = prevIframe.src;
                            if (prevSrc.includes("autoplay=1")) {
                                prevIframe.src = prevSrc.replace("autoplay=1", "autoplay=0");
                            }
                        }

                        // **Handle new active video**
                        const videoElement = activeSlide.querySelector('video');
                        if (videoElement) {
                            videoElement.src = videoElement.getAttribute('data-src');
                            videoElement.load();

                            videoElement.addEventListener('canplay', () => {
                                videoElement.play().catch((error) => console.error("Autoplay prevented:", error));
                            });

                            videoElement.muted = isMuted;
                            activeVideoRef.current = videoElement;
                            handleVideoPlay(videoElement);

                            mainSwiperRef.current.swiper.autoplay.stop();
                        } else {
                            activeVideoRef.current = null;
                        }

                        // **Enable autoplay for new YouTube iframe**
                        const iframe = activeSlide.querySelector('iframe');
                        if (iframe) {
                            let src = iframe.src;
                            if (src.includes("autoplay=0")) {
                                iframe.src = src.replace("autoplay=0", "autoplay=1");
                            }

                            mainSwiperRef.current.swiper.autoplay.stop();
                        } else {
                            if (!videoElement && mainSwiperRef.current) {
                                mainSwiperRef.current.swiper.autoplay.start();
                            }
                        }
                    }}
                >
                    { BannerArr?.length > 0 ? (
                        BannerArr?.map((banner, index) => (
                        <SwiperSlide key={index}>
                            <div className='thumbnail-container object-fit'>
                                <div className='thumbnail'>
                                    { (banner.video) ? ((banner?.video?.varMediaVideoUrlType == 'youtube') ? <iframe
                                        src={ banner?.video.varExtVideoUrl + "?autoplay=0&mute=1&controls=0&rel=0&fs=0&showinfo=0&modestbranding=1&enablejsapi=1"}
                                        alt={banner?.varTitle} title={banner?.varTitle}
                                        allowFullScreen>
                                    </iframe>
                                        :
                                        <video muted playsInline data-src={"./cdn/assets/videos/"+ banner?.video?.varVideoName + "." + banner?.video?.varVideoExtension} alt={banner?.varTitle} title={banner?.varTitle}>
                                            <source src={"./cdn/assets/videos/"+ banner?.video?.varVideoName + "." + banner?.video?.varVideoExtension} type="video/mp4" />
                                        </video>) : (banner.image) ? <Image src={banner?.fkIntImgId.webp} alt={banner?.varTitle} title={banner?.varTitle} />: ''
                                    }
                                </div>
                                <div className='caption d-flex align-items-center justify-content-center position-absolute z-1 top-0 start-0 bottom-0 end-0' data-aos="fade" data-aos-duration="2000" data-aos-delay="1000">
                                    <Container>
                                        <Row>
                                            <Col lg={12} className='text-center caption-inner'>
                                                <h2 className='title-small fw-normal text-white position-relative z-2'>{banner?.varTitle}</h2>
                                                <div className='title-big text-uppercase'>{banner?.varTagline}</div>
                                                { (banner?.chrDisplayButton == 'Y') ?
                                                    <Button className='banner-btn' variant="primary" href={banner?.varButtonLink} title={banner?.varButtonTitle}>{banner?.varButtonTitle} 
                                                    <BtnArrow/></Button>
                                                    : ''
                                                }
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                        </SwiperSlide>
                        ))
                        ) : (
                        <SwiperSlide key={1}>
                            <div className='thumbnail-container object-fit'>
                                <div className='thumbnail'>
                                    <img src={cdn_path + 'assets/images/video-img-2.avif'} alt='Discover Unique Local Treasures' title="Discover Unique Local Treasures" />
                                </div>
                                <div className='caption d-flex align-items-center justify-content-center position-absolute z-1 top-0 start-0 bottom-0 end-0' data-aos="fade" data-aos-duration="2000" data-aos-delay="1000">
                                    <Container>
                                        <Row>
                                            <Col lg={12} className='text-center '>
                                                <h2 className='title-small fw-normal text-white position-relative z-2'>Discover Unique Local Treasures</h2>
                                                <div className='title-big text-uppercase'>CRAFT MARKET</div>
                                                {/* <Button className='banner-btn' variant="primary" href="#" title='EXPLORE MORE'>EXPLORE MORE<i className="arrow"><BtnArrow/></i></Button> */}
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                        </SwiperSlide>
                        )
                    }

                </Swiper>
                <div>
                    <div className="custom-swiper-button-prev" data-aos="fade" data-aos-duration="1500" data-aos-delay="1000">
                        <img src={cdn_path + 'assets/images/home-banner-prev.svg'} alt='Previous' title="Previous" width="43" height="24" />
                    </div>
                    <div className="custom-swiper-button-next" data-aos="fade" data-aos-duration="1500" data-aos-delay="1000">
                        <img src={cdn_path + 'assets/images/home-banner-next.svg'} alt='Next' title="Next" width="43" height="24" />
                    </div>
                </div>
            </div>

            <div className='thumb-img position-absolute start-0 end-0 bottom-0 mx-auto'>
                <Swiper
                    onSwiper={setThumbsSwiper}
                    loop={true}
                    spaceBetween={30}
                    slidesPerView={1.5}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper"
                    breakpoints={{
                        0: { slidesPerView: 2 }, // iPads & Tablets
                        567: { slidesPerView: 2 }, // iPads & Tablets
                        1024: { slidesPerView: 3 }, // Small desktops
                        1440: { slidesPerView: 4 }  // Large desktops
                    }}

                    data-aos="fade-up" data-aos-duration="1500" data-aos-delay="1000" data-aos-offset="0"
                >
                    { BannerArr?.length > 0 ? (
                        BannerArr?.map((banner, index) => (
                        <SwiperSlide key={index}>
                            <div className='thumb-text position-relative text-white text-uppercase text-center'>{banner.varTagline}</div>
                        </SwiperSlide>
                    ))
                    ) : (
                        <SwiperSlide key={1}>
                            <div className='thumb-text position-relative text-white text-uppercase text-center'>CAYMAN CRAFT MARKET</div>
                        </SwiperSlide>
                        )
                    }
                </Swiper>
            </div>
        </section>
    );
}

export default Banner;
